// extracted by mini-css-extract-plugin
export default {"container":"YesNo_container__vUc2y","inputLabel":"YesNo_inputLabel__Uk33d","input":"YesNo_input__QLyQA","question":"YesNo_question__h3TL7"};